import { render, staticRenderFns } from "./LoaderButton.vue?vue&type=template&id=df999afe"
import script from "./LoaderButton.vue?vue&type=script&lang=js"
export * from "./LoaderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports